@if (company && lists) {
  @if (!section) {
    @if (company.missing?.length) {
      <div class="readiness">
        <nb-icon icon="alert-triangle-outline" status="warning"></nb-icon>
        <div>
          <span>{{ 'invoicing.company.missing' | translate }}</span>
          <ul>@for (field of company.missing; track field) { <li>{{ 'invoicing.missing.' + field | translate }}</li> }</ul>
        </div>
      </div>
    }
  }

  @if (!section || section === 'billing') { <h3>{{ 'companytabs.legal' | translate }}</h3> }
  <ul class="field-list">
    @if (shows('name')) {
      <li>
        <label><nb-icon icon="briefcase-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.company_name' | translate" [attr.aria-label]="'invoicing.explain.company_name' | translate">{{ 'invoicing.name' | translate }}</span><span class="required">*</span></label>
        <input id="company-name" nbInput [attr.aria-label]="'invoicing.name' | translate" fieldSize="small" maxlength="150" [status]="status('name')" [(ngModel)]="company.name">
        @if (warn('name')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
      </li>
    }
    @if (shows('kvk')) {
      <li>
        <label><nb-icon icon="hash-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.kvk' | translate" [attr.aria-label]="'invoicing.explain.kvk' | translate">{{ 'invoicing.kvk' | translate }}</span><span class="required">*</span></label>
        <input id="company-kvk" nbInput [attr.aria-label]="'invoicing.kvk' | translate" fieldSize="small" inputmode="numeric" placeholder="12345678" [status]="status('kvk')" [(ngModel)]="company.kvk">
        @if (error('kvk'); as message) { <span class="error">{{ message }}</span> }
        @if (warn('kvk')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
      </li>
    }
  </ul>

  @if (!section || section === 'billing') { <h3>{{ 'invoicing.group.address' | translate }}</h3> }
  <ul class="field-list">
    @if (shows('street')) {
      <li>
        <label><nb-icon icon="search-outline"></nb-icon><span>{{ 'places.find' | translate }}</span></label>
        <bst-places-editor mode="structured" fullWidth size="small" [placeholder]="'places.search' | translate" [ngModel]="null" (ngModelChange)="fill($event)"></bst-places-editor>
      </li>
    }
    @if (shows('street')) {
      <li>
        <label><nb-icon icon="home-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.street' | translate" [attr.aria-label]="'invoicing.explain.street' | translate">{{ 'invoicing.street' | translate }}</span><span class="required">*</span></label>
        <input id="company-street" nbInput [attr.aria-label]="'invoicing.street' | translate" fieldSize="small" maxlength="150" [status]="status('street')" [(ngModel)]="company.street">
        @if (warn('street')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
      </li>
    }
    @if (shows('postcode')) {
      <li>
        <label><nb-icon icon="pin-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.postcode' | translate" [attr.aria-label]="'invoicing.explain.postcode' | translate">{{ 'invoicing.postcode' | translate }}</span>@if (company.country === 'NL') {<span class="required">*</span>}</label>
        <input id="company-postcode" nbInput [attr.aria-label]="'invoicing.postcode' | translate" fieldSize="small" maxlength="16" placeholder="1234 AB" [status]="status('postcode')" [(ngModel)]="company.postcode">
        @if (error('postcode'); as message) { <span class="error">{{ message }}</span> }
        @if (warn('postcode')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
      </li>
    }
    @if (shows('town')) {
      <li>
        <label><nb-icon icon="map-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.town' | translate" [attr.aria-label]="'invoicing.explain.town' | translate">{{ 'invoicing.town' | translate }}</span><span class="required">*</span></label>
        <input id="company-town" nbInput [attr.aria-label]="'invoicing.town' | translate" fieldSize="small" maxlength="100" [status]="status('town')" [(ngModel)]="company.town">
        @if (warn('town')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
      </li>
    }
    @if (shows('country')) {
      <li>
        <label><nb-icon icon="globe-2-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.country' | translate" [attr.aria-label]="'invoicing.explain.country' | translate">{{ 'invoicing.country' | translate }}</span><span class="required">*</span></label>
        <nb-select id="company-country" [attr.aria-label]="'invoicing.country' | translate" size="small" [status]="status('country')" [(selected)]="company.country" [placeholder]="'invoicing.country' | translate">
          @for (country of countries; track country.code) { <nb-option [value]="country.code">{{ country.name }}</nb-option> }
        </nb-select>
        @if (warn('country')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
      </li>
    }
  </ul>

  @if (!section || section === 'billing') { <h3>{{ (section === 'billing' ? 'companytabs.payment' : 'invoicing.group.tax') | translate }}</h3> }
  <ul class="field-list">
    @if (shows('vat_id')) {
      <li>
        <label><nb-icon icon="percent-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.company_vat_id' | translate" [attr.aria-label]="'invoicing.explain.company_vat_id' | translate">{{ 'invoicing.company.vat_id' | translate }}</span><span class="required">*</span></label>
        <input id="company-vat_id" nbInput [attr.aria-label]="'invoicing.company.vat_id' | translate" fieldSize="small" placeholder="NL123456789B01" [status]="status('vat_id')" [(ngModel)]="company.vat_id">
        @if (error('vat_id'); as message) { <span class="error">{{ message }}</span> }
        @if (warn('vat_id')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
      </li>
    }
    @if (shows('iban')) {
      <li>
        <label><nb-icon icon="credit-card-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.iban' | translate" [attr.aria-label]="'invoicing.explain.iban' | translate">{{ 'invoicing.company.iban' | translate }}</span><span class="required">*</span></label>
        <input id="company-iban" nbInput [attr.aria-label]="'invoicing.company.iban' | translate" fieldSize="small" placeholder="NL91ABNA0417164300" [status]="status('iban')" [(ngModel)]="company.iban">
        @if (error('iban'); as message) { <span class="error">{{ message }}</span> }
        @if (warn('iban')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
      </li>
    }
    @if (shows('peppol_id')) {
      <li>
        <label><nb-icon icon="paper-plane-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.peppol_id' | translate" [attr.aria-label]="'invoicing.explain.peppol_id' | translate">{{ 'invoicing.peppol_id' | translate }}</span></label>
        <input id="company-peppol_id" nbInput [attr.aria-label]="'invoicing.peppol_id' | translate" fieldSize="small" placeholder="0106:12345678" [status]="status('peppol_id')" [(ngModel)]="company.peppol_id">
        @if (error('peppol_id'); as message) { <span class="error">{{ message }}</span> }
      </li>
    }
  </ul>

  @if (!section || section === 'billing') { <h3>{{ 'invoicing.group.start' | translate }}</h3> }
  @if (shows('invoicing_starts_on')) {
    <ul class="field-list">
      <li>
        <label><nb-icon icon="calendar-outline"></nb-icon><span tabindex="0" [nbTooltip]="'invoicing.explain.starts_on' | translate" [attr.aria-label]="'invoicing.explain.starts_on' | translate">{{ 'invoicing.company.starts_on' | translate }}</span><span class="required">*</span></label>
        <input id="company-invoicing_starts_on" nbInput [attr.aria-label]="'invoicing.company.starts_on' | translate" fieldSize="small" [placeholder]="'invoicing.company.date_format' | translate" [nbDatepicker]="startsOnPicker" [status]="status('invoicing_starts_on')" [(ngModel)]="startsOn" #startsOnModel="ngModel">
        <nb-datepicker #startsOnPicker format="DD-MM-YYYY"></nb-datepicker>
        @if (error('invoicing_starts_on'); as message) { <span class="error">{{ message }}</span> }
        @if (warn('invoicing_starts_on')) { <span class="hint warn">{{ 'companytabs.required' | translate }}</span> }
        @if (drafts.length) {
          <ul class="drafts">
            @for (draft of drafts; track draft.id) {
              <li><a [routerLink]="['/invoices', draft.id]">{{ 'invoice.draft_label' | translate:{id: draft.id} }}</a> · {{ draft.client_name }} · {{ draft.period_from | localedate:'D MMM YYYY' }} – {{ draft.period_to | localedate:'D MMM YYYY' }}</li>
            }
          </ul>
        }
      </li>
    </ul>
  }

  @for (e of otherErrors(); track $index) { <p class="error">@if (e.tab) { {{ 'companytabs.' + e.tab | translate }}: }{{ e.message }}</p> }

  <div class="actions">
    <span class="hint"><span class="required">*</span> {{ 'invoicing.required' | translate }}</span>
    <button nbButton size="small" status="primary" [disabled]="busy" (click)="save()"><nb-icon icon="checkmark"></nb-icon><span>{{ 'save' | translate }}</span></button>
  </div>
}
